import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { NotificationManager } from "react-notifications";
import store from "../../store";
import { Loader } from "../../components/loader";
import Select from "react-select";
import { forceInputUppercase } from "../../utils/helper";
import { createBreedAttribute , updateBreedAttribute } from "../../actions/breedAttribute";

const $ = window.$;

class AddBreedAttribute extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            PetId: "",          
            name : "",
            description : "",
            inputNotValid: false,
            loading : false,
            BreedAttributeId : null ,
          };      
}

  closeModal = () => {
    $("#add_breed_attribute").modal("hide");
    this.resetState();
    this.props.actionBreedAttribute();
  };

  resetState = () => {
    this.setState({
        PetId: "",
        name : "",
        description : "",
        loading: false,
        inputNotValid: false ,
        BreedAttributeId :null
    });
  };

  submitBreedAttribute(e) {
    this.setState({ loading: true });
    let data = {      
        name: this.state.name,
        description : this.state.description,
        PetShopId: this.props.petShop.currentPetshop.id,
      };
      let valid = this.state.name.length > 0;
      if (valid) {
        if(this.state.BreedAttributeId){
          data.id = this.state.BreedAttributeId;
          this.props.updateBreedAttribute(data);
          this.props.actionBreedAttribute();
        }else{
          this.props.createBreedAttribute(data);
        }      
      } else {
        e.preventDefault();
        NotificationManager.warning("Breed name cannot be empty");
        this.setState({ loading: false , inputNotValid: true });
      }
  }

  handleChange = event => {
    forceInputUppercase(event);
    const value = event.target.value;
    this.setState({
      ...this.state,
      [event.target.name]: value
    });
  };

  componentWillReceiveProps = nextProps => {  
    if (nextProps.selectedBreedAttributeData 
            && nextProps.selectedBreedAttributeData.id
            && nextProps.selectedBreedAttributeData.id !== this.state.BreedAttributeId ) {    
             this.setState({
              BreedAttributeId : nextProps.selectedBreedAttributeData.id,
              description : nextProps.selectedBreedAttributeData.description,
              name : nextProps.selectedBreedAttributeData.name,
              }, () => {               
                $("#add_breed_attribute").modal("show");
                
             });
          }
      
    if (nextProps.breedAttribute && this.props.breedAttribute !== nextProps.breedAttribute) {
      const breedAttributeExistWithSameName = '210';

      switch(nextProps.breedAttribute){
        case breedAttributeExistWithSameName:
          NotificationManager.error("Breed attribute already exists");
          this.setState({ name: "", description : "", BreedAttributeId : null, loading: false });
          $("#add_breed_attribute").modal("hide"); 
          break;
        default : 
          NotificationManager.success("Breed Attribute Added");
          this.setState({ name: "", description : "", BreedAttributeId : null, loading: false });
          $("#add_breed_attribute").modal("hide");
      }    
    }

    if (nextProps.breedAttributeUpdated && this.props.breedAttributeUpdated  !== nextProps.breedAttributeUpdated) {
      this.setState({ name: "",BreedAttributeId :null, description  : "", loading: false });
      NotificationManager.success("Breed Attribute Updated");
      $("#add_breed_attribute").modal("hide");
    }
  }

render() {
    return (
        <div
        className="modal fade show"
        id="add_breed_attribute"
        tabIndex="-1"
        role="dialog"
      >
           <div className="modal-dialog" role="document">
          <div className="modal-content">
            <form className="m-form">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  {!this.state.BreedAttributeId  ? "Add new breed attribute " : "Edit breed attribute"}
                </h5>
                <button
                  type="button"
                  className="close"
                  onClick={this.closeModal}
                  aria-label="Close"
                >
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div className="modal-body">
                <div className="row">
                  <div className="col-xl-12">
                    <div className="m-form__section m-form__section--first">
                    <div className="form-group m-form__group row">
                        <label className="col-xl-3 col-lg-3 col-form-label">
                             Name
                          </label>
                          <div className="col-xl-9 col-lg-9">
                          <input
                            type="text"
                            name="name"                         
                            value={this.state.name}
                            onChange={e => this.handleChange(e)}
                            className="form-control m-input"
                            placeholder=""
                          />
                          <span
                            className={
                              this.state.inputNotValid && this.state.name.length === 0
                                ? "m-form__help_danger"
                                : "m-form__help"
                            }
                          >
                            Please enter name
                            </span>
                          </div>
                        </div>
                        <div className="form-group m-form__group row">
                        <label className="col-xl-3 col-lg-3 col-form-label">
                            Description
                          </label>
                          <div className="col-xl-9 col-lg-9">
                          <input
                            type="text"
                            name="description"  
                            value={this.state.description}
                            onChange={e => this.handleChange(e)}                                                 
                            className="form-control m-input"
                            placeholder=""
                          />
                          
                          </div>
                        </div>
                       
                    </div>
                   </div>
                </div>
            </div>   
            <div className="modal-footer">
            {this.state.loading == false ? (
                  <div>
                    <button
                      type="button"
                      className="btn btn-secondary m-btn--pill mx-2"
                      onClick={this.closeModal}
                    >
                      Close
                      </button>
                    <button
                      onClick={(e) =>{ this.submitBreedAttribute(e); } }
                      type="submit"
                      className="btn btn-primary m-btn--pill"
                    >
                      Submit
                      </button>
                  </div>
                ) : (
                    <div className="center-row">
                      <Loader size={50} />
                    </div>
                  )}
            </div>     
        </form>
        </div>
        </div>
      </div>
    )
}

}

const mapStateToProps = state => ({
    petShop: state.petShopReducer,
    breedAttribute: state.breedAttributeReducer.setBreedAttribute,
    breedAttributeError: state.breedAttributeReducer.setBreedAttributeError,
    breedAttributeUpdated : state.breedAttributeReducer.updateBreedAttribute
  });
  
  const mapDispatchToProps = dispatch => ({
    createBreedAttribute: data => {
      dispatch(createBreedAttribute(data));
    },

    updateBreedAttribute: data => {
      dispatch(updateBreedAttribute(data));
    },
  });
  
  export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(AddBreedAttribute)
  );